import type { ReactElement } from 'react';

// Mirror apps/mobile/src/legal/legal-links.ts.
export const TERMS_OF_SERVICE_URL = 'https://groupfire.com/terms';
export const PRIVACY_POLICY_URL = 'https://groupfire.com/privacy';

export function LegalLinks(): ReactElement {
  return (
    <p className="mt-5 min-w-0 break-words text-center text-xs leading-relaxed text-gray-500 sm:text-sm">
      By continuing, you agree to GroupFire's{' '}
      <a
        href={TERMS_OF_SERVICE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="font-medium text-brand underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand"
      >
        Terms of Service<span className="sr-only"> (opens in a new tab)</span>
      </a>{' '}
      and acknowledge our{' '}
      <a
        href={PRIVACY_POLICY_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="font-medium text-brand underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand"
      >
        Privacy Policy<span className="sr-only"> (opens in a new tab)</span>
      </a>
      .
    </p>
  );
}
